module.exports = __webpack_public_path__ + "static/media/M.34e90862.jpg";